import { forwardRef, useEffect, useState } from "react";


const OtherVideoContainer = forwardRef(({
  videoLayout,
  visibleParticipants,
  canvasDimension,
  participanteLocal,
}, ref) => {

  const [otherVideoLayout, setOtherVideoLayout] = useState(null);
  useEffect(() => {

    const otherUserIndex = visibleParticipants.findIndex(
      (user) => user.userId !== participanteLocal?.userId,
    );
    if (otherUserIndex > -1) {
      const item = videoLayout[otherUserIndex];
      if (item && canvasDimension) {
        setOtherVideoLayout({
          ...item,
        });
      } else {
        setOtherVideoLayout(null);
      }
    }
  }, [
    canvasDimension,
    participanteLocal?.userId,
    videoLayout,
    visibleParticipants
  ]);


  return (
    <video-player-container
      style={
        otherVideoLayout
          ? {
            width: `${otherVideoLayout.width}px`,
            height: `${otherVideoLayout.height}px`,
            left: `${otherVideoLayout.x}px`,
            top: `${otherVideoLayout.y}px`,
            backgroundColor: "transparent",
            position: "absolute",
          }
          : { display: "none" }
      }
      ref={ref}
    />
  );
});

export default OtherVideoContainer;